import type { Market } from '@bridebook/toolbox/src/gazetteer';

/**
 * Convert place name to a link.
 * E.g. East Riding of Yorkshire converts to east-riding-of-yorkshire
 * @param slug
 * @param location
 * @param market {Market} The market to use for the url
 */
export const getSupplierSearchCategoryUrl = (
  slug: string = '',
  location: string = '',
  market: Market,
) => {
  const locationSlug = location.toLowerCase().replaceAll(' ', '-').replace(/[.,]/g, '');

  return {
    as: `/${market.prefix}/search/wedding-${slug}/${locationSlug}`,
    href: `/${market.prefix}/search?area=${locationSlug.replace('?', '&')}&slug=${slug}`,
  };
};
